import { __makeTemplateObject } from '../../_virtual/_tslib.js';
import { css } from 'styled-components';
import * as typography from '@tapas/typography';

var XLargeButtonStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  width: 18.7rem;\n  height: 7.5rem;\n"], ["\n  ", "\n  width: 18.7rem;\n  height: 7.5rem;\n"])), function (_a) {
    var theme = _a.theme;
    return typography.subheading(theme.fonts.default, 500);
});
var LargeButtonStyle = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  width: 13.4rem;\n  height: 6.4rem;\n"], ["\n  ", "\n  width: 13.4rem;\n  height: 6.4rem;\n"])), function (_a) {
    var theme = _a.theme;
    return typography.body(theme.fonts.default, 1.6, 500);
});
var MediumButtonStyle = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 11.4rem;\n  height: 5.3rem;\n"], ["\n  width: 11.4rem;\n  height: 5.3rem;\n"])));
var SmallButtonStyle = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 6.6rem;\n  height: 4.5rem;\n"], ["\n  width: 6.6rem;\n  height: 4.5rem;\n"])));
var XSmallButtonStyle = css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 5rem;\n  height: 3.7rem;\n"], ["\n  width: 5rem;\n  height: 3.7rem;\n"])));
var FullWidthButtonStyle = css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var fullwidth = _a.fullwidth;
    switch (fullwidth) {
        case 'all':
            return "\n          padding-left: 0;\n          padding-right: 0;\n          width: 100%;\n        ";
        case 'mobile':
            return "\n          @media screen and (max-width: 480px) {\n            padding-left: 0;\n            padding-right: 0;\n            width: 100%;\n          }\n        ";
        default:
            return '';
    }
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

export { FullWidthButtonStyle, LargeButtonStyle, MediumButtonStyle, SmallButtonStyle, XLargeButtonStyle, XSmallButtonStyle };
